"use strict";
// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ua_parser_js_1 = require("ua-parser-js");
var Maybe_1 = require("../maybe/Maybe");
var Versioning_1 = require("../versioning/Versioning");
var DefaultEventController = /** @class */ (function () {
    function DefaultEventController(audioVideoController) {
        var _a, _b, _c;
        this.audioVideoController = audioVideoController;
        this.meetingHistoryStates = [];
        try {
            this.parserResult =
                navigator && navigator.userAgent ? new ua_parser_js_1.UAParser(navigator.userAgent).getResult() : null;
        }
        catch (error) {
            audioVideoController.logger.error(error.message);
        }
        this.browserMajorVersion =
            ((_c = (_b = (_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.browser) === null || _b === void 0 ? void 0 : _b.version) === null || _c === void 0 ? void 0 : _c.split('.')[0]) || DefaultEventController.UNAVAILABLE;
    }
    DefaultEventController.prototype.publishEvent = function (name, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            var timestampMs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timestampMs = Date.now();
                        return [4 /*yield*/, this.pushMeetingState(name, timestampMs)];
                    case 1:
                        _a.sent();
                        this.audioVideoController.forEachObserver(function (observer) {
                            Maybe_1.default.of(observer.eventDidReceive).map(function (f) {
                                return f.bind(observer)(name, __assign(__assign({}, _this.getAttributes(timestampMs)), attributes));
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DefaultEventController.prototype.pushMeetingState = function (state, timestampMs) {
        if (timestampMs === void 0) { timestampMs = Date.now(); }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.meetingHistoryStates.push({
                    name: state,
                    timestampMs: timestampMs,
                });
                return [2 /*return*/];
            });
        });
    };
    DefaultEventController.prototype.getAttributes = function (timestampMs) {
        var _a, _b, _c, _d, _e, _f;
        return {
            attendeeId: this.audioVideoController.configuration.credentials.attendeeId,
            browserMajorVersion: this.browserMajorVersion,
            browserName: ((_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.browser.name) || DefaultEventController.UNAVAILABLE,
            browserVersion: ((_b = this.parserResult) === null || _b === void 0 ? void 0 : _b.browser.version) || DefaultEventController.UNAVAILABLE,
            deviceName: [((_c = this.parserResult) === null || _c === void 0 ? void 0 : _c.device.vendor) || '', ((_d = this.parserResult) === null || _d === void 0 ? void 0 : _d.device.model) || '']
                .join(' ')
                .trim() || DefaultEventController.UNAVAILABLE,
            externalMeetingId: typeof this.audioVideoController.configuration.externalMeetingId === 'string'
                ? this.audioVideoController.configuration.externalMeetingId
                : '',
            externalUserId: this.audioVideoController.configuration.credentials.externalUserId,
            meetingHistory: this.meetingHistoryStates,
            meetingId: this.audioVideoController.configuration.meetingId,
            osName: ((_e = this.parserResult) === null || _e === void 0 ? void 0 : _e.os.name) || DefaultEventController.UNAVAILABLE,
            osVersion: ((_f = this.parserResult) === null || _f === void 0 ? void 0 : _f.os.version) || DefaultEventController.UNAVAILABLE,
            sdkVersion: Versioning_1.default.sdkVersion,
            sdkName: Versioning_1.default.sdkName,
            timestampMs: timestampMs,
        };
    };
    DefaultEventController.UNAVAILABLE = 'Unavailable';
    return DefaultEventController;
}());
exports.default = DefaultEventController;
//# sourceMappingURL=DefaultEventController.js.map